import { GridItem } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { missingInformationAtom } from '../../../../recoil/atoms/missingInformationAtom';
import CarMissingInformationForm from '../CarMissingInformationForm';

const CarMissingInformation = (): React.JSX.Element => {
    const missingInformation = useRecoilValue(missingInformationAtom);
    const { car } = missingInformation;

    if (!car?.length) return <></>;

    return (
        <>
            {car
                .filter((missingInformation) => !!missingInformation.fixedId)
                .map((missingInformation) => {
                    return (
                        <GridItem span={12} key={missingInformation.fixedId}>
                            <CarMissingInformationForm carMissingDTO={missingInformation} />
                        </GridItem>
                    );
                })}
        </>
    );
};

export default CarMissingInformation;
